import { Col, Form, Icon, Input, Row } from 'antd'
import withSort from '../elements/HOC/withSort'
import withSpinning from '../elements/HOC/withSpinning'
import useFetchSelect from '../elements/Hooks/useFetchSelect'
import CustomDebounceSelect from '../elements/Select/CustomDebounceSelect'
import withUrlFetch from '../elements/Select/withUrlFetch'
import { get, isEmpty } from 'lodash'
import React, { useEffect, useState } from 'react'
import { compose } from 'recompose'
import AddPhoneBook from '../components/Main/Modal/AddPhoneBook'
import FormSectionTitle from '../elements/FormSectionTitle'
import useModalShow from '../elements/Hooks/useModalShow'
import { defaultFormItemLayout, rules } from '../modules/FormItems'
import CountrySelect from './Select/Country'
import CustomSelect from './Select/CustomSelect'

const OrganisationSelect = compose(
  withUrlFetch({
    name: 'members',
    url: 'members/list?select=fn,_key,_id,kind,address,phone,email',
    cache: true,
    forceFetch: false,
  }),
  withSpinning,
  withSort
)(CustomDebounceSelect)

function ContactDetails(props) {
  const { doc, prefix, title, getFieldDecorator, getFieldValue, setFieldsValue, hide = [], require = true } = props

  const attrPrefix = prefix ? `${prefix}.` : ''
  // const [rep, setRep] = useState({})
  const [companyInfo, setCompanyInfo] = useState({})

  // const { SelectData: OrganisationSelect, selected: companyInfo } = useFetchSelect({
  //   url: 'members/list?select=fn,_key,_id,kind,address',
  // })

  const isIndividual = get(companyInfo, 'kind') === 'individual'

  const company = getFieldValue(`${attrPrefix}company._id`) || ''

  const { SelectData: RepSelect, selected: rep } = useFetchSelect({
    url: company ? `${company}/representatives` : 'members/list?select=fn,_key,_id,kind,address,phone,email',
    dependencyArray: [company],
    dontFetch: isEmpty(company),
  })

  const info = isIndividual ? companyInfo : rep

  const RepEmailSelect = compose(
    withUrlFetch({
      name: 'repEmail',
      url: `contacts/email/${get(info, '_key')}`,
      dontFetch: isEmpty(info),
    }),
    withSpinning
  )(CustomSelect)

  //console.log(rep)

  useEffect(() => {
    if (!isEmpty(info)) {
      setFieldsValue({
        [`${attrPrefix}email.label`]: get(info, isIndividual ? 'email.label' : 'email'),
        [`${attrPrefix}phone.label`]: get(info, isIndividual ? 'phone.label' : 'phone'),
      })
    }
  }, [info])

  useEffect(() => {
    if (!isEmpty(companyInfo)) {
      setFieldsValue({
        //[`${attrPrefix}email.label`]: get(companyInfo, 'email.label'),
        //[`${attrPrefix}phone.label`]: get(companyInfo, 'phone.label'),
        [`${attrPrefix}address.country`]: get(companyInfo, 'address.country'),
        [`${attrPrefix}address.label`]: get(companyInfo, 'address.label'),
      })
    }
  }, [rep])

  const [modalID, setModalID] = useState(1)
  const { visible: visiblePhonebook, onShow: onShowPhoneBook, onCancel: onCancelPB } = useModalShow()

  function onCancelPhoneBook() {
    setModalID((old) => old + 1)
    onCancelPB()
  }

  return (
    <Row>
      <AddPhoneBook
        key={modalID}
        visible={visiblePhonebook}
        handleCancel={onCancelPhoneBook}
        handleOk={onCancelPhoneBook}
      />
      {title && <FormSectionTitle title={title} />}
      <Col span={12}>
        <Form.Item {...defaultFormItemLayout} label={isIndividual ? 'Company' : 'Notify Party'}>
          {getFieldDecorator(`${attrPrefix}company._id`, {
            initialValue: get(doc, `${attrPrefix}company._id`),
          })(
            <OrganisationSelect keyAtr={'_id'} valueAtr={'fn'} setSelected={setCompanyInfo} style={{ width: '85%' }} />
          )}
          <Icon style={{ marginLeft: 5 }} type="plus-circle" onClick={onShowPhoneBook} />
        </Form.Item>
      </Col>

      {!isIndividual && (
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Rep">
            {getFieldDecorator(`${attrPrefix}notify._id`, {
              initialValue: get(doc, `${attrPrefix}notify._id`),
              rules: require ? rules.select : null,
            })(
              <RepSelect
                keyAtr={'_id'}
                valueAtr={'fn'}
                // setSelected={setRep}
                style={{ width: '85%' }}
              />
            )}
            <Icon style={{ marginLeft: 5 }} type="plus-circle" onClick={onShowPhoneBook} />
          </Form.Item>
        </Col>
      )}

      {!hide.includes('address') && (
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Full Address">
            {getFieldDecorator(`${attrPrefix}address.label`, {
              initialValue: get(doc, `${attrPrefix}address.label`),
            })(<Input style={{ width: '100%' }} />)}
          </Form.Item>
        </Col>
      )}
      {!hide.includes('country') && (
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'Country'}>
            {getFieldDecorator(`${attrPrefix}address.country`, {
              initialValue: get(doc, `${attrPrefix}address.country`),
            })(<CountrySelect />)}
          </Form.Item>
        </Col>
      )}
      {!hide.includes('email') && (
        <Col span={12}>
          <Form.Item label="Email" {...defaultFormItemLayout}>
            {getFieldDecorator(`${attrPrefix}email.label`, {
              initialValue: get(doc, `${attrPrefix}email.label`),
              rules: [
                {
                  required: true,
                  message: "Email can't be empty ",
                },
              ],
            })(<RepEmailSelect valueAtr={'label'} keyAtr={'label'} placeholder="Email" />)}
          </Form.Item>
        </Col>
        /*<Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Email">
            {getFieldDecorator(`${attrPrefix}email.label`, {
              initialValue: get(doc, `${attrPrefix}email.label`),
            })(<Input style={{ width: '100%' }} />)}
          </Form.Item>
        </Col>*/
      )}

      {!hide.includes('phone') && (
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="phone">
            {getFieldDecorator(`${attrPrefix}phone.label`, {
              initialValue: get(doc, `${attrPrefix}phone.label`),
            })(<Input style={{ width: '100%' }} />)}
          </Form.Item>
        </Col>
      )}
    </Row>
  )
}

export default ContactDetails
